import { Box, Typography, Button, Container } from "@mui/material";
import {
  FacebookIcon,
  TwitterIcon,
  InstagramIcon,
  LinkedinIcon,
  YoutubeIcon,
  GithubIcon,
} from "lucide-react";
import React from "react";

import { useHandleSocial } from "0.Mine/1.Hooks/social/social";
import { useBusinessContext } from "0.Mine/2.Context/businessContext";
import { SocialMediaIdentifier } from "0.Mine/3.Interfaces/social";
const SocialConnectPage: React.FC = () => {
  const socialIcons = [
    {
      Icon: FacebookIcon,
      color: "#1877F2",
      delay: 0,
    },
    {
      Icon: TwitterIcon,
      color: "#1DA1F2",
      delay: 0.2,
    },
    {
      Icon: InstagramIcon,
      color: "#E4405F",
      delay: 0.4,
    },
    {
      Icon: LinkedinIcon,
      color: "#0A66C2",
      delay: 0.6,
    },
    {
      Icon: YoutubeIcon,
      color: "#FF0000",
      delay: 0.8,
    },
  ];

  const { connectSocial } = useHandleSocial();
  const { session } = useBusinessContext();

  if (!session || !session.selectedBusiness) {
    return <p>Seleziona un business</p>;
  }

  return (
    <Container
      maxWidth={false}
      sx={{
        width: "100%",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        bgcolor: "background.default",
        padding: 3,
      }}
    >
      <Box
        sx={{
          position: "relative",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: 4,
          borderRadius: 4,
          bgcolor: "white",
          boxShadow: 3,
          maxWidth: "600px",
          width: "100%",
          textAlign: "center",
        }}
      >
        <Typography
          variant="h4"
          component="h1"
          gutterBottom
          sx={{
            mb: 6,
            color: "text.primary",
          }}
        >
          Collega i tuoi social in un qlick
        </Typography>
        <Box
          sx={{
            position: "relative",
            width: 200,
            height: 200,
            mb: 6,
          }}
        >
          {/* Central Button */}
          <Button
            variant="contained"
            color="primary"
            size="large"
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: 120,
              height: 120,
              borderRadius: "50%",
              zIndex: 10,
              fontSize: "1rem",
              fontWeight: "bold",
              boxShadow: 4,
              transition: "box-shadow 0.3s, filter 0.3s",
              "&:hover": {
                transform: "translate(-50%, -50%)", // Keep the same transform on hover
                boxShadow: "0 0 20px 5px rgba(25, 118, 210, 0.6)", // Add glow effect with primary color
                filter: "brightness(1.1)",
              },
            }}
            onClick={async () =>
              connectSocial(session.selectedBusiness.id, SocialMediaIdentifier.FACEBOOK)
            }
          >
            Collega
          </Button>
          {/* Social Icons */}
          {socialIcons.map(({ Icon, color, delay }, index) => {
            // Calculate position in a circle around the button
            const angle = index * (360 / socialIcons.length) * (Math.PI / 180);
            const radius = 100; // Distance from center
            const left = Math.cos(angle) * radius + 100; // 100 is half of container width
            const top = Math.sin(angle) * radius + 100; // 100 is half of container height
            return (
              <Box
                key={index}
                sx={{
                  position: "absolute",
                  left: left - 20,
                  top: top - 20,
                  width: 40,
                  height: 40,
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  bgcolor: "white",
                  boxShadow: 2,
                  opacity: 0,
                  animation: `fadeIn 0.5s ease-out forwards ${delay}s`,
                  transition: "transform 0.3s, boxShadow 0.3s",
                  "&:hover": {
                    transform: "scale(1.2)",
                    boxShadow: 4,
                    cursor: "pointer",
                  },
                  "@keyframes fadeIn": {
                    "0%": {
                      opacity: 0,
                      transform: "scale(0.5)",
                    },
                    "100%": {
                      opacity: 1,
                      transform: "scale(1)",
                    },
                  },
                }}
              >
                <Icon size={24} color={color} />
              </Box>
            );
          })}
        </Box>
        <Typography variant="body1" color="text.secondary">
          Semplifica la tua presenza online collegando tutti i tuoi profili social
        </Typography>
      </Box>
    </Container>
  );
};
export default SocialConnectPage;
